import { TabView, TabPanel } from "primereact/tabview";
import React, { useEffect, useState } from "react";
import { getGroupItemFirst, groupByItemType } from "../utils/GroupByItem";
import { useTranslation } from "react-i18next";

function CustomTabs({
  tabs,
  className = "",
  tabClassName = "",
  panelClassName = "",
  navClassName = "",
  activeTabIndex = 0,
  activeChildTabIndex = 0,
  setActiveTabIndex = () => { },
  setActiveChildTabIndex = () => { },
  setCategory = () => { },
  setFieldValue = () => { },
  billingVisitData = null,
}) {
  const [currentIndex, setCurrentTabIndex] = useState(activeTabIndex);
  const [childIndex, setChildIndex] = useState(activeChildTabIndex);
  const { t } = useTranslation()
  useEffect(() => {
    if (activeTabIndex !== currentIndex) {
      setChildIndex(activeChildTabIndex);
      setCurrentTabIndex(activeTabIndex);
      if (setCategory) {
        setCategory(activeTabIndex === 0 ? "out_patient" : "in_patient");
      }
    }
  }, [activeTabIndex]);

  useEffect(() => {
    if (billingVisitData) {
      setChildIndex(0);
      setCurrentTabIndex(
        Object?.values(
          groupByItemType(
            billingVisitData?.items?.filter(
              (item) => item?.status?.toLowerCase() == "unpaid"
            ) || []
          )
        )?.length - 1
      );
    }
  }, [billingVisitData]);

  return (
    <div className="mt-2">
      <TabView
        activeIndex={currentIndex}
        onTabChange={(e) => {
          const newIndex = e.index;
          setChildIndex(0);
          if (setFieldValue && billingVisitData) {
            setFieldValue(
              "items",
              getGroupItemFirst(billingVisitData, newIndex)
            );
          }
          if (setCategory) {
            setCategory(newIndex === 0 ? "out_patient" : "in_patient");
          }
          setCurrentTabIndex(newIndex);
          if (setActiveTabIndex) {
            setActiveTabIndex(newIndex);
          }
        }}
        className={`custom-tabview ${className}`}
        pt={{
          nav: { className: `w-full border-b border-b-gray-300 mb-3 ${navClassName}` },
          tablink: {
            className: `
              hover:!border-b-[#0070C2] 
              [&[data-p-highlight=true]]:!border-b-[#0070C2] 
              rounded-t-md transition-all duration-200
              border-b-1 border-transparent
              focus:!outline-offset-none focus:outline-none focus-visible:outline-none
              ${tabClassName}`,
          },
          panelcontainer: {
            className: `bg-transparent ${panelClassName} !p-0`,
          },
        }}
      >
        {tabs?.map((tab, index) => (
          <TabPanel
            header={
              <div className="flex items-center gap-2">
                <h5 className="text-[16px] !font-semibold">
                  {typeof tab?.name === 'string' ? t(tab?.name) : tab?.name}
                </h5>
                {tab?.children ? <i className="pi pi-angle-down"></i> : ""}
              </div>
            }
            key={index}
            className={`!bg-transparent ${panelClassName}`}
            pt={{
              headeraction: {
                className: `!m-0 !rounded-none ${index === 0 ? "!rounded-tl-md" : ""
                  } ${index === tabs.length - 1 ? "!rounded-tr-md" : ""
                  } focus:!border-transparent focus-visible:!border-transparent !bg-transparent focus:!outline-none focus-visible:!outline-none !border-b-0`,
              },
              headerTitle: {
                className: "text-gray-700 text-[16px] font-[600]",
              },
              headeraction: { className: "!py-2 !px-5" },
              content: { className: "!p-3 !pt-0" },
            }}
          >
            {tab.children ? (
              <TabView
                className="child-tabview"
                activeIndex={childIndex}
                onTabChange={(e) => {
                  const newIndex = e.index;
                  setChildIndex(newIndex);
                  setActiveChildTabIndex(newIndex);

                  if (setFieldValue && billingVisitData) {
                    setFieldValue(
                      "items",
                      getGroupItemFirst(
                        billingVisitData,
                        currentIndex,
                        newIndex == 1 ? "insurance" : "cash"
                      )
                    );
                  }
                }}
                pt={{
                  nav: { className: "w-full border-b border-b-gray-300 flex" },

                  tablink: {
                    className:
                      "border-b-1 border-transparent hover:border-gray-400 flex-1 justify-center",
                  },
                  panelcontainer: { className: "bg-transparent px-0" },
                }}
              >
                {tab.children.map((child, childIndex) => (
                  <TabPanel
                    key={childIndex}
                    header={child.name}
                    className="!bg-transparent"
                    pt={{
                      headeraction: { className: "!m-0 !py-[0.5rem] !px-5 !border-0 !flex-1" },
                      content: { className: "!pt-2" },
                    }}
                  >
                    {typeof (
                      child.content ??
                      (child.reuseFirstChildContent
                        ? tab.children[0]?.content
                        : null)
                    ) === "function"
                      ? (
                        child.content ??
                        (child.reuseFirstChildContent
                          ? tab.children[0]?.content
                          : null)
                      )()
                      : child.content ??
                      (child.reuseFirstChildContent
                        ? tab.children[0]?.content
                        : null)}
                  </TabPanel>
                ))}
              </TabView>
            ) : typeof tab.content === "function" ? (
              tab.content()
            ) : (
              tab.content
            )}
          </TabPanel>
        ))}
      </TabView>
    </div>
  );
}

export default CustomTabs;
